import React from 'react'
import Navbar from '../components/Navbar'

export default function MainLayout({ children, title = '', subtitle = '', Buttons }) {
    return (
        <div className="min-h-screen bg-gray-50">
            <Navbar />

            {/* Content column — offset by sidebar width on md+ */}
            <div className="md:pl-60">
                {/* Page header */}
                <header className="bg-white border-b border-gray-200 sticky top-0 z-10">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
                        <div className="min-w-0">
                            <h1 className="text-lg sm:text-xl font-semibold text-gray-900 truncate">
                                {title}
                            </h1>
                            {subtitle && (
                                <p className="text-xs text-gray-500 truncate">{subtitle}</p>
                            )}
                        </div>
                        {Buttons && (
                            <div className="flex items-center gap-2 shrink-0">{Buttons}</div>
                        )}
                    </div>
                </header>

                <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    {children}
                </main>
            </div>
        </div>
    )
}
